import { useIntl } from 'react-intl';
import { useSnackbar } from 'notistack';
import apiService from 'library/api-service';
import { useCallback, useEffect, useState } from 'react';
import { FreshdeskDashboardResponse } from 'library/types';

const useFreshdeskDashboard = (take: number) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [dashboard, setDashboard] = useState<FreshdeskDashboardResponse | null>(null);

  const getDashboard = useCallback(async () => {
    try {
      setLoading(true);
      setHasError(false);

      const response = await apiService.getFreshdeskDashboard(take);

      if (!response.isSuccess) {
        throw new Error(response.message || intl.formatMessage({ id: 'freshdesk.loadError' }));
      }

      setDashboard(response.data);
    } catch (error) {
      const message =
        error instanceof Error && error.message ? error.message : intl.formatMessage({ id: 'freshdesk.loadError' });

      setHasError(true);
      enqueueSnackbar(message, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  }, [take, intl, enqueueSnackbar]);

  useEffect(() => {
    getDashboard();
  }, [getDashboard]);

  return {
    dashboard,
    loading,
    hasError,
    initialLoading: loading && !dashboard,
    refresh: getDashboard,
  };
};

export default useFreshdeskDashboard;
